import { Controller } from '@hotwired/stimulus'

// Inline required-field errors on blur - the Hotwire form carries no validation library.
// InfoRequestsHelper#info_request_field_error renders the same markup server-side.
export default class extends Controller {
  static values = { message: String }

  validate(event) {
    const field = event.target
    if (!field.matches?.('[required]')) return

    const errorContainer = field.closest('.field.form-group')?.querySelector('.error-message')
    if (!errorContainer) return

    const isEmpty = field.type === 'checkbox' ? !field.checked : field.value.trim() === ''
    errorContainer.innerHTML = ''

    if (isEmpty) {
      const label = document.createElement('label')
      label.setAttribute('role', 'alert')
      label.className = 'error'
      label.textContent = this.messageValue
      errorContainer.appendChild(label)
    }
  }
}
